<template>
  <div>
    <div class="page-body--top margin-bottom-1rem">
      <c-block-box
        title="融媒体事业部"
        class="page-body--top-box margin-right-1rem"
      >
        <div
          slot="sub-title"
          id="details-btn"
          class="digital-btn coocaa_btn"
          leftTarget="#details-btn"
          upTarget="#Parlor"
          router="/kanban-config-view?id=8"
          rel="digitalDetails"
          @click="seeDetails('/kanban-config-view?id=8')"
        >
          详情
        </div>
        <div class="top-box">
          <div class="top-box--flex">
            <div class="tendency-title">总营收（万元）</div>
            <div class="value">{{ numberSplitWithComma((mfData.mediaMonthIncome || 0) * 1) }}</div>
            <div class="tendency">
              <div class="tendency-text">
                <span>环比</span>
                <img :src="upsAndDowns(mfData.mediaMonthRatio)" />
                <em>{{ percentage(mfData.mediaMonthRatio || 0) }}%</em>
              </div>
              <div class="tendency-text">
                <span>同比</span>
                <img :src="upsAndDowns(mfData.mediaMonthYRatio)" />
                <em>{{ percentage(mfData.mediaMonthYRatio || 0) }}%</em>
              </div>
            </div>
            <c-target-rate
              label="完成率"
              :target="`${mfData.mediaMonthTarget || 0} 万`"
              :num="percentage((mfData.mediaMonthFinishRatio || 0) * 1)"
              height=".7rem"
            ></c-target-rate>
            <c-target-rate
              label="匹配度"
              :num="percentage((mfData.mediaTargetFinishRatio || 0) * 1)"
              height=".7rem"
            ></c-target-rate>
          </div>
          <!-- <div class="top-box--flex top-box--flex3">
            <div class="tendency-title">月新增融媒体终端数（台）<c-manual-icon></c-manual-icon></div>
            <div class="value">{{ numberSplitWithComma((mfData.mediaDeviceAdd || 0) * 1) }}</div>
            <div class="tendency">
              <div class="tendency-text">
                <span>月环比</span>
                <img :src="upsAndDowns(mfData.mediaDeviceMonthRatio)" />
                <em>{{ percentage(mfData.mediaDeviceMonthRatio || 0) }}%</em>
              </div>
            </div>
            <c-target-rate
              label="累计融媒体终端数："
              :target="numberSplitWithComma((mfData.mediaDeviceTotal || 0) * 1)"
              :is-progress="false"
            ></c-target-rate>
          </div> -->
        </div>
      </c-block-box>
      <c-block-box title="外部家庭终端业务" class="page-body--top-left">
        <div class="top-box">
          <div class="top-box--flex1">
            <div class="tendency-title">总营收（万元）</div>
            <div class="value">{{ numberSplitWithComma((mfData.outMonthIncome || 0) * 1) }}</div>
            <div class="tendency">
              <div class="tendency-text">
                <span>环比</span>
                <img :src="upsAndDowns(mfData.outMonthRatio)" />
                <em>{{ percentage(mfData.outMonthRatio || 0) }}%</em>
              </div>
              <div class="tendency-text">
                <span>同比</span>
                <img :src="upsAndDowns(mfData.outMonthYRatio)" />
                <em>{{ percentage(mfData.outMonthYRatio || 0) }}%</em>
              </div>
            </div>
            <c-target-rate
              label="完成率"
              :target="`${mfData.outMonthTarget || 0} 万`"
              :num="percentage(mfData.outMonthFinishRatio * 1)"
              height=".7rem"
            ></c-target-rate>
            <c-target-rate
              label="匹配度"
              :num="percentage((mfData.outTargetFinishRatio || 0) * 1)"
              height=".7rem"
            ></c-target-rate>
          </div>
          <div class="top-box--flex2">
            <div class="tendency-title">新增家庭终端数(万台)</div>
            <div class="value">{{ numberSplitWithComma((mfData.outDeviceAdd || 0) * 1) }}</div>
            <div class="tendency">
              <div class="tendency-text">
                <span>环比</span>
                <img :src="upsAndDowns(mfData.outDeviceMonthRatio)" />
                <em>{{ percentage(mfData.outDeviceMonthRatio || 0) }}%</em>
              </div>
            </div>
            <c-target-rate
              label="累计数外部终端数："
              :target="`${numberSplitWithComma((mfData.outDeviceTotal || 0) * 1)}(万台)`"
              :is-progress="false"
            ></c-target-rate>
            <c-target-rate
              label="当前占整体比例："
              :target="`${percentage(mfData.outDeviceToAllRatio * 1)} %`"
              :is-progress="false"
            ></c-target-rate>
          </div>
          <div class="top-box--flex">
            <div class="tendency-title">累计终端数及占比</div>
            <div class="terminal-box">
              <div class="terminal-pie">
                <ChartPie
                  v-if="mediaFinancialPieTotal.data.length > 0"
                  id="devicePie"
                  height="6.5rem"
                  width="6.5rem"
                  :option="mediaFinancialPieTotal"
                ></ChartPie>
              </div>
              <div class="device-pie--line">
                <div class="line" v-for="(item, key) in mediaFinancialPieTotal.data" :key="'t_' + key">
                  <span>{{ item.name }}</span>
                  <em>{{ item.num }}万台</em>
                  <em>{{ item.value * 1 }}%</em>
                </div>
              </div>
            </div>
          </div>
        </div>
      </c-block-box>
    </div>
    <div class="page-body">
      <div class="main-body--left">
        <c-block-box
          title="业务拓展核心指标"
          class="margin-bottom-1rem"
        >
          <div class="table-item">
            <div class="table-head">
              <div class="head-item" style="width:200px">核心指标</div>
              <div class="head-item">本月目标</div>
              <div class="head-item">当前完成</div>
              <div class="head-item" style="padding: 0 1rem;width: 6rem">完成比例</div>
            </div>
            <div class="table-body">
              <div class="table-line" v-for="(tableItem, index) in mfData.indicators" :key="index">
                <div class="body-lable" style="width:200px">{{ tableItem.dictLabel }}</div>
                <div class="body-lable">{{ tableItem.indicatorValueA }}</div>
                <div class="body-lable">
                  <span>{{ tableItem.indicatorValueB }}</span>
                  <!-- <i v-if="index > 0" class="manual">手动</i> -->
                </div>
                <div class="body-lable" style="padding: 0 1rem;width: 6rem">
                  <c-progress
                    class="c-progress"
                    height="1.1rem"
                    style="margin-top:.45rem"
                    :num="percentage(tableItem.indicatorValueC * 1).toFixed(2)"
                  ></c-progress>
                </div>
              </div>
            </div>
          </div>
        </c-block-box>
        <c-block-box title="核心业务指标增长趋势">
          <div style="height: 19.5rem;padding: 0 1.5rem; padding-top:1px">
            <ChartBarLine
              style="margin-top: .8rem"
              v-for="(item, index) in barLine"
              :key="index"
              :id="`iuiehege-${index}`"
              height="8.5rem"
              :name="item.name"
              :option="item.option"
            ></ChartBarLine>
          </div>
        </c-block-box>
      </div>
      <div class="main-body--right">
        <c-block-box title="近3月项目支撑情况">
          <div class="business-tags" slot="sub-title">
            <span>启动阶段</span>
            <span class="span1">实施阶段</span>
            <span class="span2">收尾阶段</span>
          </div>
          <project-list :project="mfData.projects"></project-list>
        </c-block-box>
      </div>
    </div>
  </div>
</template>

<script>
import ChartBarLine from '@/components/echarts/line2'
import ChartPie from '@/components/echarts/pie'
import common from '@/mixins/common.js'
import ProjectList from './components/ProjectList'
export default {
  mixins: [common],
  components: {
    ChartBarLine,
    ChartPie,
    ProjectList
  },
  props: {},
  data () {
    return {
      // 累计终端数及占比图
      mediaFinancialPieTotal: {
        config: {
          type: 2,
          picRadius: '70%',
          tooltip: {
            show: false
          },
          seriesLabel: {
            show: false
          },
          legend: {
            show: false
          }
        },
        data: []
      },
      // 核心业务指标增长趋势图
      barLine: [],
      mfData: {}
    }
  },
  computed: {
    isAndroid () {
      return this.$store.state.app.isAndroid
    }
  },
  methods: {
    seeProject (item) {
      if (item.projectStatus === 20) {
        this.$router.push({
          name: 'ssp-project',
          query: {
            id: item.projectId
          }
        })
      }
    },
    removeArray (arr, val) {
      for (var i = 0; i < arr.length; i++) {
        if (arr[i] === val) {
          arr.splice(i, 1)
          break
        }
      }
    },
    formatLine (data) {
    },
    getProject () {
      const yearMonth = JSON.parse(sessionStorage.getItem('toggleDate')).time
      const isAndroid = this.$store.state.app.isAndroid
      this.barLine = []
      this.$service.fetch({
        url: 'api/media/dashboard_new',
        method: 'get',
        params: {
          yearMonth
        }
      }).then(res => {
        this.$set(this, 'mfData', res)
        this.mediaFinancialPieTotal.data = res.pieChart.map(item => {
          return {
            name: item.name,
            value: parseFloat((item.value * 100).toFixed(2)),
            num: parseFloat(((item.name.indexOf('创维') >= 0 ? res.skyWorth : res.other) / 10000).toFixed(2))
          }
        })
        const lineData = [{
          name: '事业部营收趋势',
          data: res.divisionIncome
        },
        {
          name: '外部终端数量趋势',
          data: res.deviceNum
        }]
        this.barLine = lineData.map((item, index) => {
          const data = item.data
          const legendData = Object.keys(data)
          const option = {
            config: {
              // color: index ? ['#01b93b', '#c58100', '#c33400', '#0400c5'] : null,
              xData: data[legendData[0]].date.map(item => {
                return this.$cUtils.format.formatDate(item, 'MM-dd')
              }),
              legendData: legendData,
              splitNumber: 2,
              grid: {
                top: 30,
                right: 0
              },
              yAxis: [],
              legend: {
                right: 0
              }
            },
            data: []
          }
          Object.values(data).map((rows, index) => {
            if (item.name === '外部终端数量趋势') {
              option.config.grid.top = 45
              option.data.push({
                name: legendData[index],
                data: Object.values(rows)[1],
                symbol: 'none',
                lineStyle: {
                  width: isAndroid ? 0.5 : 2
                },
                yAxisIndex: index
              })
              option.config.yAxis.push(
                {
                  name: index > 0 ? '万台' : '台',
                  // min: index > 0 ? 1700 : 25,
                  type: 'value',
                  splitLine: {
                    lineStyle: {
                      color: 'rgba(255,255,255,0.1)'
                    }
                  },
                  axisLine: {
                    show: false
                  },
                  axisLabel: {
                    show: true,
                    textStyle: {
                      color: 'rgba(255,255,255,.6)'
                    }
                  },
                  nameTextStyle: {
                    color: '#999',
                    fontSize: isAndroid ? 10 : 12
                  },
                  splitNumber: 2
                }
              )
            } else {
              option.data.push({
                name: legendData[index],
                data: Object.values(rows)[1],
                symbol: 'none',
                lineStyle: {
                  type: legendData[index] === '目标' ? 'dashed' : 'solid',
                  width: isAndroid ? 0.5 : 2
                }
              })
            }
          })
          return {
            name: item.name === '外部终端数量趋势' ? item.name : item.name + '/万元',
            option: option
          }
        })
      })
    },
    getTimestamp (date) {
      return Date.parse(new Date(date))
    }
  },
  created () {
  },
  activated () {
    this.getProject()
  }
}
</script>

<style lang="stylus" scoped>
  @import './stylus/MediaFinancial.styl'
  @import './stylus/Project-list.styl'
</style>
